import React from 'react';

import { reverse } from 'named-urls';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import routes from 'core/routes';
import { EntityModules } from 'core/constants';
import { useNavBarHeight } from 'utils/hooks/navbar';

import { useStore } from 'utils/hooks/store';

import SchedulesTable from './components/SchedulesTable';

const Schedules: React.FunctionComponent = (): React.ReactElement => {
  const { routing, session } = useStore();
  const navBarHeight = useNavBarHeight();
  const refreshRef = React.useRef<Function | null>(null);

  const auditsAsEntity = !!session.user?.activeEntityModules.includes(EntityModules.Audits);

  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  const handleNewButtonClick = (): void => {
    routing.push(reverse(routes.dashboard.schedules.new));
  };

  return (
    <Record
      Header={
        <MainHeader
          title="Schedules"
          breadcrumbs={
            auditsAsEntity
              ? [
                  { label: 'Audits', link: routes.dashboard.audits.forms.toString() },
                  { label: 'Schedules', link: routes.dashboard.schedules.toString() },
                ]
              : [
                  { label: 'Schedules', link: routes.dashboard.schedules.toString() },
                  { label: 'Overview', link: routes.dashboard.schedules.toString() },
                ]
          }
          action={
            <Button variant="contained" size="large" onClick={handleNewButtonClick}>
              New
            </Button>
          }
        />
      }
      Content={(onError) => <SchedulesTable onError={onError} onRefreshCallback={onRefreshCallback} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default Schedules;
